
import { Grid, Card, Skeleton, CardContent } from "@mui/material"

export const CardEmpty = () => {

    return (
        
        <Grid size={{ xs: 12, sm: 6, lg: 4, xl: 3 }}>

            <Card>  
                
                <Skeleton variant="rectangular" height={240} />

                <CardContent sx={{ height: 50 }}>

                    <Skeleton animation="wave" height={35} width="100%" /> 

                </CardContent>              

            </Card>       

        </Grid>                
    )
}
